import { imgSrc } from "./media";
import { txt } from "./format";

export const FONTS_EN = {
  Outfit: "400;500;600;700;800;900",
  "Plus Jakarta Sans": "400;500;600;700;800",
  "Bricolage Grotesque": "400;500;600;700;800",
  Syne: "400;500;600;700;800",
  Fraunces: "400;500;600;700;800;900",
  "DM Serif Display": "400",
};
export const FONTS_AR = {
  Cairo: "400;500;600;700;800;900",
  Tajawal: "400;500;700;800;900",
  Almarai: "400;700;800",
  "IBM Plex Sans Arabic": "400;500;600;700",
  "Noto Kufi Arabic": "400;500;600;700;800",
  "El Messiri": "400;500;600;700",
  "Readex Pro": "400;500;600;700",
};

export function loadFonts(names) {
  const fams = names
    .filter((n) => FONTS_EN[n] || FONTS_AR[n])
    .map((n) => `family=${n.replace(/ /g, "+")}:wght@${FONTS_EN[n] || FONTS_AR[n]}`)
    .join("&");
  const href = `https://fonts.googleapis.com/css2?${fams}&display=swap`;
  let el = document.getElementById("wt-fonts");
  if (!el) {
    el = document.createElement("link");
    el.id = "wt-fonts";
    el.rel = "stylesheet";
    document.head.appendChild(el);
  }
  if (el.getAttribute("href") !== href) el.setAttribute("href", href);
}

export function themeVars(s, lang) {
  const t = s.theme;
  const font = lang === "ar" ? `'${t.font_ar}', '${t.font_en}', sans-serif` : `'${t.font_en}', '${t.font_ar}', sans-serif`;
  return {
    "--wt-primary": t.primary,
    "--wt-secondary": t.secondary,
    "--wt-bg": t.bg,
    "--wt-surface": t.surface,
    "--wt-card": t.card,
    "--wt-text": t.text,
    "--wt-muted": t.muted,
    "--wt-price": t.price || t.primary,
    "--wt-radius": `${t.radius}px`,
    "--wt-gap": `${t.spacing}px`,
    "--wt-font": font,
    "--wt-aspect": s.menu.aspect,
    "--cols-m": s.menu.cols_mobile,
    "--cols-t": s.menu.cols_tablet,
    "--cols-d": s.menu.cols_desktop,
    "--hero-m": `${s.hero.height_mobile}px`,
    "--hero-d": `${s.hero.height_desktop}px`,
  };
}

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value || "");
}

export function applySeo(s, lang) {
  const title = txt(s.seo, "title", lang) || txt(s.brand, "name", lang);
  const desc = txt(s.seo, "description", lang);
  document.title = title;
  setMeta("name", "description", desc);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", desc);
  setMeta("property", "og:locale", lang === "ar" ? "ar_SA" : "en_US");
  setMeta("name", "theme-color", s.theme.bg);
  if (s.seo.og_image_url) setMeta("property", "og:image", imgSrc(s.seo.og_image_url, "lg"));
  if (s.seo.favicon_url) {
    let link = document.head.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = imgSrc(s.seo.favicon_url, "sm");
  }
}
